import './menu-toggle.css';
export default {
  "check": "pf-v5-c-check",
  "checkInput": "pf-v5-c-check__input",
  "menuToggle": "pf-v5-c-menu-toggle",
  "menuToggleButton": "pf-v5-c-menu-toggle__button",
  "menuToggleControls": "pf-v5-c-menu-toggle__controls",
  "menuToggleCount": "pf-v5-c-menu-toggle__count",
  "menuToggleIcon": "pf-v5-c-menu-toggle__icon",
  "menuToggleStatusIcon": "pf-v5-c-menu-toggle__status-icon",
  "menuToggleText": "pf-v5-c-menu-toggle__text",
  "menuToggleToggleIcon": "pf-v5-c-menu-toggle__toggle-icon",
  "modifiers": {
    "primary": "pf-m-primary",
    "secondary": "pf-m-secondary",
    "expanded": "pf-m-expanded",
    "plain": "pf-m-plain",
    "text": "pf-m-text",
    "fullHeight": "pf-m-full-height",
    "disabled": "pf-m-disabled",
    "typeahead": "pf-m-typeahead",
    "splitButton": "pf-m-split-button",
    "action": "pf-m-action",
    "active": "pf-m-active",
    "fullWidth": "pf-m-full-width",
    "success": "pf-m-success",
    "warning": "pf-m-warning",
    "danger": "pf-m-danger"
  },
  "textInputGroup": "pf-v5-c-text-input-group",
  "themeDark": "pf-v5-theme-dark"
};